$(document).ready(function() {

	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
  }
  
  $('.hp-bottom-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    fade: true,
    dots: false,
    rtl: dirRtlFlag,
    autoplay: true,
    adaptiveHeight: true,
    pauseOnHover: false
  });

	$('.prods-slider').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 6,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 3000,
		rtl: dirRtlFlag,
		responsive: [{
				breakpoint: 1600,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 1100,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 998,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

// instagram slider
if ($('#instafeed').length > 0) {
  var feed = new Instafeed({
    accessToken: $('#instafeed').data('token'),
    template: '<a href="{{link}}"><img alt="{{caption}}" src="{{image}}" /></a>',
    after: function() {
      var dirRtlFlag = false;
      if ($("html").attr('dir') == 'rtl') {
        dirRtlFlag = true;
      }
      $('#instafeed').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2000,
        rtl: dirRtlFlag,
        slidesToShow: 6,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [{
            breakpoint: 1600,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });

      // fix drag on gallery
      $('#instafeed').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('body').addClass('lg-on');
      });

      $('#instafeed').on('afterChange', function(event, slick, currentSlide) {
        $('body').removeClass('lg-on');
      });
    }
  });
  feed.run();
}


})

